import { medicalExpenseTypeLabels } from '../labels';

export function transformMedicalExpenses(formData) {
  const parsedFormData = JSON.parse(formData);
  const transformedValue = { ...parsedFormData };
  if (parsedFormData?.medicalExpenses?.length) {
    transformedValue.medicalExpenses = parsedFormData.medicalExpenses.map(
      expense => {
        const transformedExpense = { ...expense };
        if (medicalExpenseTypeLabels[expense.purpose]) {
          transformedExpense.purpose =
            medicalExpenseTypeLabels[expense.purpose]?.label;
        }
        return transformedExpense;
      },
    );
  }
  return JSON.stringify(transformedValue);
}
